import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { useNotificationItemComponentStyle } from './notifications-item-component.styles'

export const NotificationPlaceholder: React.FC = () => {
  const classes = useNotificationItemComponentStyle()
  return (
    <div className={classes.placeholderContainer}>
      <div className={classes.placeholderIconCell}>
        <Skeleton
          animation="wave"
          variant="circle"
          className={classes.placeholderIconSkeleton}
        />
      </div>
      <div className={classes.placeholderContent}>
        <Skeleton
          animation="wave"
          variant="rect"
          className={classes.placeholderChipSkeleton}
        />
        <div className={classes.placeholderSummary}>
          <div className={classes.placeholderTitleBlock}>
            <Skeleton animation="wave" width="48%" height={24} />
            <Skeleton animation="wave" width="28%" height={18} />
          </div>
          <Skeleton
            animation="wave"
            variant="circle"
            className={classes.placeholderExpandSkeleton}
          />
        </div>
      </div>
    </div>
  )
}
